interface ProgressProps {
  value: number;
  className?: string;
}

export const Progress: React.FC<ProgressProps> = ({ value, className = "" }) => {
  return (
    <div className={`bg-gray-100 rounded-full overflow-hidden ${className}`}>
      <div 
        className="h-full bg-gradient-to-r from-orange-500 to-pink-500 transition-all duration-300"
        style={{ width: `${value}%` }}
      />
    </div>
  );
}; 